import { Component, input, Input, OnInit } from '@angular/core';
import { BreezeCase } from '../../../utils/types/convert-case';
import { Customer } from '../../../data/models';

@Component({
    selector: 'app-client-jobs',
    templateUrl: './client-jobs.component.html',
    standalone: false,
})
export class ClientJobsComponent {
    // from route resolver
    client = input.required<BreezeCase<Customer> | undefined>({ alias: 'customer' });
}
